import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardTitle, Collapse} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {confirmAlert} from 'react-confirm-alert';
import {connect} from "react-redux";


// components
import ServiceLocationForm from "./_form";
import ServicesLocationFilters from "./_filters";
import TranslateButton from "../../../components/buttons/TranslateButton";

// labels
import {ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, LIST, NO, YES } from "../../../components/i18n/i18n";
import {ButtonTableDelete, ButtonTableEdit, ButtonTableFilter,} from "../../../components/buttons/buttonsActions";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// actions
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setViewMode, setLoading, setMapConfig} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search} from "../../../redux/actions/eventx/servicesLocationsActions";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";

// service
import {serviceLocationService} from "../../../jwt/_services/clasificator/serviceLocationService";

function ServiceLocationList(props) {
    const [collapsed, setCollapsed] = useState(true);
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps
    const { udn, mapConfig } = props.mainProps;
    const [staticFilter, setStaticFilter] = useState({
        fbDataBase : {  id : null },
        item : {
            udn : { id : udn.id }
        }
    })

    useEffect(()=>{
        setStaticFilter({
            ...staticFilter,
            fbDataBase: { id : props.mainProps?.app?.fbDataBase?.id },
            item :{
                udn : { id : udn.id }
            }
        })
    },[props.mainProps?.app?.fbDataBase?.id, udn?.id])

    useEffect(() => {
        if(!staticFilter.fbDataBase.id || !staticFilter.item.udn || !staticFilter.item.udn.id)
            return;
        if ( filter === undefined || filter === null){
            refreshDataList(pageIndex, pageSize, staticFilter);
            return;
        }
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter, staticFilter]);

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{ARE_YOU_SHURE_TITLE}</h1>
            <p>{ARE_YOU_SHURE_MSG}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                deleteItem(data)
                onClose();
            }}>
                {YES}
            </button>
        </div>
    });

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const deleteItem = (data) => props.remove(data.id, props.mainProps?.app?.fbDataBase?.id)

    const editItem = (data) => {
        props.setForm(true, false, false);
        props.setItem(data);
        props.setMapConfig({
            ...mapConfig,
            mapOptions : {
                ...mapConfig.mapOptions,
                center: {
                    lat: parseFloat(data?.latitude),
                    lng: parseFloat(data?.longitude)
                }
            }
        });
        ModalFormContainer(ServiceLocationForm, { data: data, Form: ServiceLocationForm})
    }

    // ----------------------------------------------
    //            FORM BEHAVIOR
    // ----------------------------------------------

    const showFilters = () => setCollapsed(!collapsed);

    // ----------------------------------------------
    //            ROW FORMATTERS
    // ----------------------------------------------

    const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={serviceLocationService} />
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>


    const columns = [
        {
            dataField: 'id',
            text: 'ID',
            headerStyle: {width: '0px'},
            hidden: true
        }, {
            dataField: 'uid',
            headerStyle: {width: '200px'},
            text: 'UID'
        }, {
            dataField: 'name',
            headerStyle: {width: '200px'},
            text: 'Nombre'
        }, {
            dataField: 'tsCode',
            headerStyle: {width: '200px'},
            text: 'Tipo'
        }, {
            dataField: 'latitude',
            headerStyle: {width: '100px'},
            text: 'Latitud'
        }, {
            dataField: 'longitude',
            headerStyle: {width: '100px'},
            text: 'Longitud'
        }, {
            dataField: 'schedule12',
            headerStyle: {width: '150px'},
            text: 'Horario'
        }, {
            dataField: 'status',
            headerStyle: {width: '50px'},
            text: "Activo",
            headerAlign: 'center',
            align:'center',
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerStyle: {width: '15%'},
            headerAlign: 'center',
            align:'center',
            formatter: actionsFormatter
        }
    ];

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <div className="float-left">
                <i className="far fa-list-alt mr-2"> </i> {LIST}
            </div>
            <div className="float-right">
                <ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
            </div>
        </CardTitle>
        <Collapse isOpen={collapsed}>
            <ServicesLocationFilters />
        </Collapse>
        <CardBody className="border-top">
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={columns}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={handleTableChange}
            />
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setLoading,
    setViewMode,
    setMapConfig,
    setForm,
    setItem,
    search,
    remove,
})
export default connect(mapStateToProps, mapActionsToProps)(ServiceLocationList)
